import { waffleCharm_ariaLabel } from './WaffleCharm.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import HeaderCharm from './HeaderCharm';

import { HeaderCharmType } from 'owa-header-store';
import { WafflePane } from 'owa-header-pane';
import { observer } from 'mobx-react-lite';
import { ControlIcons } from 'owa-control-icons';

const styles = require('./Header.scss');

const WaffleCharm = observer(function WaffleCharm(props: {}) {
    return (
        <HeaderCharm
            key="waffle"
            icons={{ iconName: ControlIcons.Waffle }}
            title={loc(waffleCharm_ariaLabel)}
            ariaLabel={loc(waffleCharm_ariaLabel)}
            className={styles.waffle}
            activeClassName={styles.activeWaffle}
            behavior={{
                paneComponent: WafflePane,
                charm: HeaderCharmType.WaffleCharm,
            }}
        />
    );
});
export default WaffleCharm;
